import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "border-bottom mb-3" }
const _hoisted_2 = { class: "mb-3 row" }
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "mb-3 row" }
const _hoisted_5 = { class: "col-sm-9" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "mb-3 row" }
const _hoisted_13 = { class: "col-sm-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "mb-4 row" }
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_21 = { class: "mb-3 row" }
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = { class: "mb-3 row" }
const _hoisted_24 = { class: "col-sm-9" }
const _hoisted_25 = { class: "audits-grid" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["href"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["href"]
const _hoisted_35 = { key: 1 }

import {ref, reactive, computed, watch} from "vue";
import {BInput, BDatePicker} from "./Fields";
import BGrid from "./BGrid/BGrid.vue";
import {BTableColumn} from "./BTable/BTable.types";

import Multiselect from "@vueform/multiselect";

import {useOriStore} from "@/stores/oriStore";

import InformationModal from "./Misc/InformationModal.vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import {SelectItem, UploadType} from "@/types";
import {useAuditStore} from "@/stores/auditStore";
import type {Audit} from "../audit.types";
import {useFormValidation} from "../validation";
import {object, string, date} from "yup";
import {useAgencyContactsStore} from "@/stores/agencyContactsStore";
import {debounce} from "vue-debounce";
import {convertToUTC} from "@/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'Audits',
  props: {
    title: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props;

var updateData = debounce(() => getData(), "15000ms");

const audit = ref<Audit>({} as Audit);

const isShowCreateEditor = ref(false);

const startMonth = ref();
const endMonth = ref();

watch(startMonth, (newStartMonth) => {
    if (newStartMonth) {
        audit.value!.startMonth = convertToUTC(new Date(newStartMonth.year, newStartMonth.month, 1));
    }
});

watch(endMonth, (newEndMonth) => {
    if (newEndMonth) {
        audit.value!.endMonth = convertToUTC(new Date(newEndMonth.year, newEndMonth.month + 1, 0));
    }
});

const auditStore = useAuditStore();
const agencyContactsStore = useAgencyContactsStore();

const schema = object<Audit>({
    auditName: string().required().label("Audit Name"),
    agency: string().required().label("Agency"),
    startDate: date().required().label("Start Date"),
    plannedEndDate: date()
        .required()
        .label("End Date")
        .when("startDate", (startDate, schema) => {
            if (audit.value.startDate) {
                const dayAfter = new Date(new Date(audit.value!.startDate).getTime() + 86400000);
                return schema.min(dayAfter, "End date cannot be earlier than start date");
            }
            return schema;
        }),
    startMonth: date().required().label("Start Month"),
    agencyContactRole: string().required().label("Agency Contact"),
    endMonth: date()
        .required()
        .label("End Month")
        .when("plannedEndDate", (plannedEndDate, schema) => {
            if (audit.value.plannedEndDate) {
                var endDate = new Date(audit.value!.plannedEndDate);
                const dayAfter = new Date(endDate.getFullYear(), endDate.getUTCMonth() + 1, 1);
                return schema.max(dayAfter, "End month cannot be later than when the Audit is taking place");
            }
            return schema;
        })
        .when("startMonth", (startMonth, schema) => {
            if (audit.value.startMonth) {
                const dayAfter = new Date(audit.value.startMonth.getTime() + 86400000);
                return schema.min(dayAfter, "End month has to be no earlier than start month");
            }
            return schema;
        }),
    auditorName: string().required().label("Auditor Name"),
    auditorEmailAddress: string().email().label("Auditor Email Address"),
});

const oriStore = useOriStore();
oriStore.dataset = UploadType.nibrs;

const agencies = computed(() => {
    const values = oriStore.oris;
    let list = values.map(
        (m) =>
            ({
                label: `${m.ori} - ${m.agency}`,
                value: m.ori,
            } as SelectItem)
    );

    return list;
});

const columns = reactive<BTableColumn[]>([
    {
        key: "auditName",
        text: "Audit Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["auditName"],
    },
    {
        key: "agency",
        text: "Agency Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["agencyName"],
    },
    {
        key: "startDate",
        text: "Start Date",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item.startDate,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item["status"],
    },

    {
        key: "incidents",
        text: "Documents requested",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documents"],
    },
    {
        key: "documentsAccepted",
        text: "Documents accepted",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documentsAccepted"],
    },

    {
        key: "incidents",
        text: "Incidents",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["incidents"],
    },
    {
        key: "uploadedNarratives",
        text: "Uploaded Narratives",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: false,
        value: (item) => item["uploadedNarratives"],
    },
    {
        key: "completedReviews",
        text: "Completed Reviews",
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
        sortable: false,
        value: (item) => item["completedReviews"],
    },
    {
        key: "passedReviews",
        text: "Passed Reviews",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: true,
        value: (item) => item["passedReviews"],
    },
    {
        key: "reportFileId",
        text: "Report File",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-wrap"],
        value: (item) => item["reportFileId"],
    },
]);

const showCreateEditor = async function () {
    audit.value = {} as Audit;
    resetValidation();
    isShowCreateEditor.value = true;
    let user = await auditStore.getCurrentUser();
    audit.value.auditorEmailAddress = user.email;
    audit.value.agencyContactRole = "0";
    audit.value.auditorName = `${user.firstName} ${user.lastName}`.trim();
    startMonth.value = "";
    endMonth.value = "";
};
const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};
const getData = async function () {
    await auditStore.list();
    await updateData();
};

const canAdd = computed(() => props.createAudits);

const canDelete = function (): boolean {
    return props.runAudits;
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

const createAudit = async () => {
    if (await handleSubmit(schema, audit.value)) {
        await auditStore.create(audit.value);
        await getData();
        await hideCreateEditor();
        audit.value = {} as Audit;
    }
};

;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => agencyContactsStore.list())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationModal, {
      title: "Delete",
      key: "confirmDialog",
      ref: "confirmDialog",
      "show-footer": true,
      className: "confirm",
      onDismiss: hideCreateEditor
    }, {
      footer: _withCtx(() => _cache[9] || (_cache[9] = [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal"
        }, " No ", -1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          "data-bs-dismiss": "modal"
        }, " Yes ", -1)
      ])),
      default: _withCtx(() => [
        _cache[10] || (_cache[10] = _createTextVNode(" Are You Sure? ", -1))
      ]),
      _: 1,
      __: [10]
    }, 512),
    _createVNode(InformationModal, {
      title: "Create Audit",
      "show-modal": isShowCreateEditor.value,
      ref: "createDialog",
      onDismiss: hideCreateEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(createAudit, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                for: "auditorName",
                class: "col-sm-3 col-form-label"
              }, "Audit Name:", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(BInput), {
                  name: "auditorName",
                  type: "text",
                  modelValue: audit.value.auditName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((audit.value.auditName) = $event)),
                  error: _unref(errors).auditName
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "disabledSelect",
                class: "col-sm-3 col-form-label"
              }, "Agency:", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Multiselect), {
                  modelValue: audit.value.agency,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((audit.value.agency) = $event)),
                  options: agencies.value,
                  multiple: false,
                  "close-on-select": true,
                  class: _normalizeClass({'is-invalid': !!_unref(errors).agency}),
                  label: 'label',
                  searchable: true,
                  "filter-results": true,
                  strict: false,
                  submit: false,
                  "native-support": true
                }, null, 8, ["modelValue", "options", "class"]),
                (_unref(errors).agency)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(errors).agency), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Period Under Review:", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", {
                      for: "startMonth",
                      class: "col-form-label"
                    }, "Start Month:", -1)),
                    _createVNode(_unref(BDatePicker), {
                      name: "startMonth",
                      error: _unref(errors).startMonth,
                      "month-picker": true,
                      modelValue: startMonth.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startMonth).value = $event))
                    }, null, 8, ["error", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", {
                      for: "endMonth",
                      class: "col-form-label"
                    }, "End Month:", -1)),
                    _createVNode(_unref(BDatePicker), {
                      name: "endMonth",
                      error: _unref(errors).endMonth,
                      "month-picker": true,
                      modelValue: endMonth.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endMonth).value = $event))
                    }, null, 8, ["error", "modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Audit to Take Place", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "startDate",
                      class: "col-form-label"
                    }, "Start Date:", -1)),
                    _createVNode(_unref(BDatePicker), {
                      name: "startDate",
                      error: _unref(errors).startDate,
                      modelValue: audit.value.startDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((audit.value.startDate) = $event))
                    }, null, 8, ["error", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      for: "plannedEndDate",
                      class: "col-form-label"
                    }, "End Date:", -1)),
                    _createVNode(_unref(BDatePicker), {
                      name: "plannedEndDate",
                      error: _unref(errors).plannedEndDate,
                      modelValue: audit.value.plannedEndDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((audit.value.plannedEndDate) = $event))
                    }, null, 8, ["error", "modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                for: "agencyContactRole",
                class: "col-sm-3 col-form-label"
              }, "Agency Contact:", -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  id: "agencyContactRole",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((audit.value.agencyContactRole) = $event)),
                  class: "form-select"
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("option", { value: "0" }, "N/A", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agencyContactsStore).items, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.value,
                      key: item.value
                    }, _toDisplayString(item.label), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, audit.value.agencyContactRole]
                ]),
                (_unref(errors).agencyContactRole)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(errors).agencyContactRole), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "auditorName",
                class: "col-sm-3 col-form-label"
              }, "Auditor Name:", -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(BInput), {
                  name: "auditorName",
                  type: "text",
                  modelValue: audit.value.auditorName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((audit.value.auditorName) = $event)),
                  error: _unref(errors).auditorName
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "auditorEmailAddress",
                class: "col-sm-3 col-form-label"
              }, "Auditor Email Address:", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(BInput), {
                  name: "auditorEmailAddress",
                  type: "text",
                  modelValue: audit.value.auditorEmailAddress,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((audit.value.auditorEmailAddress) = $event)),
                  error: _unref(errors).auditorEmailAddress
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "submit"
            }, " Save ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(SystemAlerts),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(BGrid, {
        caption: "List of audits",
        tableOptions: _unref(auditStore).tableOptions,
        filterableFields: _unref(auditStore).filterableFields,
        filterOptions: _unref(auditStore).filterOptions,
        onOptionChange: getData,
        items: _unref(auditStore).items,
        columns: columns,
        loading: _unref(auditStore).loading
      }, {
        beforeFilter: _withCtx(() => [
          (canAdd.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(showCreateEditor, ["prevent"]),
                class: "btn btn-primary"
              }, " Create Audit "))
            : _createCommentVNode("", true)
        ]),
        "cell.auditName": _withCtx(({item}) => [
          (item.status == 'In Progress' || item.status == 'Closed' || item.status == 'New')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                href: `AgencyCommunicationAuditsDetails.aspx?id=${item.id}`
              }, _toDisplayString(item["auditName"]), 9, _hoisted_26))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item["auditName"]), 1))
        ]),
        "header.documentsAccepted": _withCtx(() => _cache[24] || (_cache[24] = [
          _createTextVNode(" (% of requested) ", -1)
        ])),
        "cell.documentsAccepted": _withCtx(({item}) => [
          (item.documentsAccepted)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.documentsAccepted) + " (" + _toDisplayString(item.documentsAcceptedPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.uploadedNarratives": _withCtx(() => _cache[25] || (_cache[25] = [
          _createTextVNode(" (% of incidents) ", -1)
        ])),
        "cell.uploadedNarratives": _withCtx(({item}) => [
          (item.uploadedNarratives)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.uploadedNarratives) + " (" + _toDisplayString(item.uploadedNarrativesPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.completedReviews": _withCtx(() => _cache[26] || (_cache[26] = [
          _createTextVNode(" (% of incidents) ", -1)
        ])),
        "cell.completedReviews": _withCtx(({item}) => [
          (item.completedReviews)
            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(item.completedReviews) + " (" + _toDisplayString(item.completedReviewsPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.passedReviews": _withCtx(() => _cache[27] || (_cache[27] = [
          _createTextVNode(" (% of completed reviews) ", -1)
        ])),
        "cell.passedReviews": _withCtx(({item}) => [
          (item.passedReviews)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.passedReviews) + " (" + _toDisplayString(item.passedReviewsPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "cell.status": _withCtx(({item}) => [
          (item.status == 'Failed')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                href: `AgencyCommunicationAuditsDetails.aspx?id=${item.id}`
              }, _toDisplayString(item["status"]), 9, _hoisted_32))
            : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(item["status"]), 1))
        ]),
        "cell.reportFileId": _withCtx(({item}) => [
          (item.reportFileId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `api/v1/audit/file/${item.reportFileId}`,
                class: "btn btn-sm btn-secondary"
              }, "View Report", 8, _hoisted_34))
            : (_openBlock(), _createElementBlock("span", _hoisted_35))
        ]),
        _: 1
      }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
    ])
  ], 64))
}
}

})